import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString, deleteQueryString } from 'services/router/actions';

// Workspaces
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    clearable?: boolean;
    singleFilter?: boolean;
}

const FertilizerProductDropdown = ({
    clearable,
    singleFilter
}: Props): React.ReactElement => {
    const dispatch = useDispatch();

    const fertilizerProductId: number = useSelector(
        makeSelectQueryStringNumberValue('fertilizerProductId')
    );
    const fertilizerProductOptions = useSelector(selectOptions);

    const handleChange = (event: any, data: any) => {
        if (singleFilter) dispatch(deleteQueryString());

        dispatch(updateQueryString({ fertilizerProductId: data.value }));
    };

    return (
        <Dropdown
            placeholder="All Products"
            search
            selection
            value={fertilizerProductId}
            clearable={clearable}
            selectOnBlur={false}
            options={fertilizerProductOptions}
            onChange={handleChange}
            lazyLoad
            closeOnChange
            fluid
        />
    );
};

FertilizerProductDropdown.defaultProps = {
    clearable: true,
    singleFilter: false
};

export default FertilizerProductDropdown;
